import { VFileInput } from 'vuetify/lib/components/VFileInput';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"drop":function($event){$event.preventDefault();return _vm.onChange.apply(null, arguments)},"dragover":function($event){$event.preventDefault();}}},[_c(VFileInput,_vm._b({attrs:{"value":_vm.file,"loading":_vm.loading,"error":!!_vm.errorMessage.length,"error-messages":_vm.errorMessage,"hint":_vm.getHint},on:{"click:clear":_vm.deleteFile,"change":_vm.onChange}},'v-file-input',_vm.localProps,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }